module.exports = __webpack_public_path__ + "static/@1x-aesthetics-xs-fbd622b815e8fc1fbf417c594af97572.jpg";